export default class BestRoute {
  constructor(api) {
    this.api = api;
  }

  getObjects(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/fiberterminalboxes/preview", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(node, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/fiberterminalboxes/generate", node)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  clusterToolPreview(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/micro-routing-closures/preview", data)
      .then(resp => {
        onSuccess(resp.data.data);
      })
      .catch(error => {
        onError(error);
      });
  }
  clusterToolCreate(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/micro-routing-closures/", data)
      .then(resp => {
        onSuccess(resp.data.data);
      })
      .catch(error => {
        onError(error);
      });
  }
  redrawCluster(uuid, onSuccess, onError){
    return this.api.http_fibercloud
      .put("v1/fiberterminalboxes/redraw/"+uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/cluster.js